import React from 'react';
import landingImage from '../assets/images/7574.jpg';
import globalStore from '../store/global';
import { Link } from 'wouter';
import Slider, { SlideItem } from './Slider';


import slide01 from '../assets/images/slider/50_descuento_sin_boton_nueva.png';
import slide02 from '../assets/images/slider/Consultas_medicas_sin_copago_con_boton.jpg';
import slide03 from '../assets/images/slider/Cobertura_de_viaje_sin_boton.png';
import slide04 from '../assets/images/slider/Foto_chica.png'
import slide05 from '../assets/images/slider/partners_con_boton_nueva.png';
import slide06 from '../assets/images/slider/medico_a_domicilio_sin_boton.png';
import slide07 from '../assets/images/slider/Seguro_de_Vida_y_Sepelio_con_boton.png';
import slide08 from '../assets/images/slider/servicios.png';
import slide09 from '../assets/images/slider/descuento_en_farmacia_con_boton.png';
import slide10 from '../assets/images/slider/Telemedicina_con_boton.png';

//import { useStore } from 'zustand';

import ContenedorAnimacion from './ContenedorAnimacion';
//import logotexto from './../assets/images/logo_vidaplus_transparente_200x60.png'
import logotexto from './../assets/images/logotipo.jpg'

import SearchIcon from '@mui/icons-material/Search';


interface HeroProps {
    id: string;
}

const Hero: React.FC<HeroProps> = ({ id }) => {

  const { seccion, setSeccion } = globalStore();

  const handleServiciosClick = () => {
    if (seccion !== 'servicios') setSeccion('servicios');
    window.location.href = '#servicios';
  };

    const slides: SlideItem[] = [
        { img: slide01, link: '' },
        { img: slide02, link: '' },
        { img: slide03, link: '' },
        { img: slide04, link: '' },
        { img: slide05, link: '' },
        { img: slide06, link: '' },
        { img: slide07, link: '' },
        { img: slide08, link: '' },
        { img: slide09, link: '' },
        { img: slide10, link: '' },
    ];

  return (
      <section id={id} className="bg-white flex pt-[90px] items-center justify-center min-h-screen">
          <div className="flex flex-col items-center md:flex-row">
              <ContenedorAnimacion animation='slideInLeft' duration={600} delay={1} className="">
                  <div className="flex flex-col m-2 px-4">
                      <div className="flex justify-start items-start">
                        <img src={logotexto} className="mb-4 h-[100px] hidden xxs:flex xxs:h-[40px] xs:flex xs:h-[60px] xs:mb-2 sm:flex sm:h-[80px] md:flex md:h-[100px]" alt="VidaPlus Logo" />
                      </div>
                      <h2 className="font-metropolis mb-12 xxs:mb-4 xs:mb-6 sm:mb-8 md:mb-10 text-xl sm:text-2xl md:text-2xl lg:text-3xl xl:text-4xl tracking-tight font-regular text-gray-900 ">Reinventamos la forma de cuidarte.</h2>
                      <h2 className="font-metropolis text-md sm:text-md md:text-lg lg:text-xl xl:text-2xl md:mt-10 text-left text-vp-azul leading-tight font-bold">Vida<span className={`text-vp-verde font-metropolis font-bold`}>Plus</span><span className='text-vp-gris font-metropolis font-light'>, el nuevo servicio que permite elegir la cobertura que más necesitas, sumando la mejor protección. No somos ni obra social ni una prepaga: somos una alternativa flexible pensada para complementar tu cobertura actual.</span></h2>
                      <h3
                          className="font-metropolis mt-6 text-md sm:text-md md:text-lg lg:text-xl xl:text-2xl md:mt-10 text-left text-gray-700 font-light">
                          Nacimos para cuidarte a vos y a tu familia a un costo inigualable. Podés acceder a la amplia cartilla de prestadores y las mejores empresas de seguros del país.
                      </h3>
                      <ContenedorAnimacion animation='fadeIn' duration={600} delay={600} className="">
                        <div className="flex flex-col sm:flex-row justify-center my-4 mx-2 gap-3 xs:mx-3 md:mx-0 md:justify-start">
                            <Link className="flex flex-grow" to="/Cotizador">
                                <button className="vp-btn-verde flex-grow shadow-md shadow-vp-gris">Cotizar YA!</button>
                            </Link>
                            <Link className="flex flex-grow" to="/Buscador">
                                <button className="vp-btn-azul flex-1 shadow-md shadow-vp-gris"><SearchIcon />Servicios</button>
                            </Link>
                            <Link className="flex flex-grow" to="/Credencial">
                                <button className="vp-btn-verde flex-1 shadow-md shadow-vp-gris mr-2">Tu Credencial</button>
                            </Link>
                        </div>
                      </ContenedorAnimacion>
                  </div>
              </ContenedorAnimacion>
              <ContenedorAnimacion animation='slideInRight' duration={600} delay={5} className="">
                  {
                  /*<div className={`flex justify-center md:justify-end p-3`}>
                      <img src={landingImage} className='rounded-xl shadow-xl shadow-vp-gris' alt="mockup" />
                  </div>
                  */
                  }
                  <div className="flex flex-col px-4 xs:w-[400px] sm:w-[500px] md:w-[600px] lg:w-[700px] xl:w-[800px]">
                    <Slider items={slides} />
                  </div>
              </ContenedorAnimacion>
          </div>
      </section>        
  );
};


export default Hero;